import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./styles/ResetPassword.css";

const ResetPassword = () => {
  const { t } = useTranslation();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [confirmValidDataPopup, setConfirmValidDataPopup] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
    if (!passwordRegex.test(password)) {
      alert(t("resetPassword.alertInvalidPassword"));
      return;
    }

    if (password !== confirmPassword) {
      alert(t("resetPassword.alertPasswordsMismatch"));
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || t("resetPassword.alertGenericError"));
      }

      setConfirmValidDataPopup(true);
    } catch (error) {
      console.error("Erreur lors de l'enregistrement:", error);
      alert(error.message);
    }
  };

  const handleClosePopup = () => {
    navigate("/login");
  };

  return (
    <main className="reset-password">
      {confirmValidDataPopup && (
        <div className="reset-password-popup">
          <div className="reset-password-popup-content">
            <p>{t("resetPassword.successMessage")}</p>
            <button onClick={handleClosePopup}>{t("resetPassword.validateButton")}</button>
          </div>
        </div>
      )}

      <div className="reset-password-form-container">
        <form className="reset-password-form" onSubmit={handleSubmit}>
          <h1 className="reset-password-form-title">{t("resetPassword.title")}</h1>

          <div className="reset-password-form-input">
            <label htmlFor="newPassword">{t("resetPassword.labels.newPassword")}</label>
            <input
              id="newPassword"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="reset-password-form-input">
            <label htmlFor="confirmPassword">{t("resetPassword.labels.confirmPassword")}</label>
            <input
              id="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <div className="reset-password-form-row button-row">
            <button type="submit">{t("resetPassword.submit")}</button>
          </div>
        </form>
      </div>
    </main>
  );
};

export default ResetPassword;
